import { FilterItem } from '../filters';

export enum EventType {
  EVENT = 'event',
  CASE = 'case',
}

export const EVENT_TYPE_MAP = {
  [EventType.EVENT]: 'Событие',
  [EventType.CASE]: 'Дело',
};

export const EVENT_TYPE_ARRAY: FilterItem<string>[] = Object.values(EventType).map((eventTypes) => ({ id: eventTypes, label: EVENT_TYPE_MAP[eventTypes] }));


export enum EventTaskType {
  CALL_IN = 'call_in',
  MISSED_CALL = 'missed_call',
  CALL_OUT = 'call_out',
  EMAIL_IN = 'email_in',
  EMAIL_OUT = 'email_out',
  MEETING = 'meeting',
  WAZZUP = 'wazzup',
  CASE = 'case',
}

export const EVENT_TASK_TYPE_MAP = {
  [EventTaskType.CALL_IN]: 'Входящий звонок',
  [EventTaskType.MISSED_CALL]: 'Пропущенный звонок',
  [EventTaskType.CALL_OUT]: 'Исходящий звонок',
  [EventTaskType.EMAIL_IN]: 'Входящий емейл',  
  [EventTaskType.EMAIL_OUT]: 'Исходящий емайл',
  [EventTaskType.MEETING]: 'Встреча',  
  [EventTaskType.WAZZUP]: 'Wazzup',
  [EventTaskType.CASE]: 'Дело',  
};

export const EVENT_TASK_TYPE_ARRAY: FilterItem<string>[] = Object.values(EventTaskType).map((eventTaskTypes) => ({ id: eventTaskTypes, label: EVENT_TASK_TYPE_MAP[eventTaskTypes] }));

type CallTaskType = EventTaskType.CALL_IN | EventTaskType.MISSED_CALL | EventTaskType.CALL_OUT;

export const CALL_TYPE_MAP: Record<CallTaskType, string> = {
  [EventTaskType.CALL_IN]: 'Входящий звонок',
  [EventTaskType.MISSED_CALL]: 'Пропущенный звонок',
  [EventTaskType.CALL_OUT]: 'Исходящий звонок',
};

export const CALL_TYPE_ARRAY: FilterItem<string>[] = ([
  EventTaskType.CALL_IN,
  EventTaskType.MISSED_CALL, 
  EventTaskType.CALL_OUT
] as CallTaskType[]).map(type => ({ 
  id: type, 
  label: CALL_TYPE_MAP[type] 
}));